import React from "react";
import i18n from "../lib/i18n-test";
import "./AssetCaption.style.scss";
export interface AssetCaptionProps {
    assetType?: string;
    caption?: string;
    source_credit?: string;
    use_caption?: boolean;
}

export const AssetCaption = (props: AssetCaptionProps) => {
    const caption = props.use_caption && props.caption ? props.caption : null;

    if (!caption && !props.source_credit) {
        return null;
    }

    return (
        <p className="component-asset-caption">
            {caption ? <span className="asset-caption">{caption}</span> : null}
            {props.source_credit ? (
                <span className="asset-credit">
                    {i18n.t(`${props.assetType}`)}: {props.source_credit}
                </span>
            ) : null}
        </p>
    );
};

export default AssetCaption;
